import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import { Stack } from '@mantine/core';
import './index.scss';
import AdminLogin from './AdminLogin';
import AthleteLogin from './AthleteLogin';
import ForgotPassword from './ForgotPassword';
import Code from './Code';

import logo from '@assets/images/tc-gymnasium-logo.png';

export default function Auth() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <div className="login-page">
            <div className="login">
              <img src={logo} alt="T&C's Gymnasium" />
              <p className="login-tagline">Training Tracker</p>
              <Stack gap="md" align="center" mt="lg" w="100%">
                <Link className="login-cta" to="/admin">
                  Admin login
                </Link>
                <Link className="login-secondary-link" to="/athlete">
                  Athlete login
                </Link>
              </Stack>
            </div>
          </div>
        }
      />
      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/athlete" element={<AthleteLogin />} />
      <Route
        path="/admin-forgot-password"
        element={<ForgotPassword isAdmin />}
      />
      <Route
        path="/athlete-forgot-password"
        element={<ForgotPassword isAthlete />}
      />
      <Route path="/code/:id" element={<Code />} />
      <Route path="*" element={<AdminLogin />} />
    </Routes>
  );
}
